// @flow
import React from 'react'
import ResponsiveModal from 'react-responsive-modal'
import { translations, translateFunc } from '../../shared/localize'
import styled from 'styled-components'

const t = translateFunc(translations.provider.modal)

const SearchInput = styled.input`
  font-size: 14px;
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 15px;
  margin: 0 5px 0 0;
  text-align: left;
  width: 100%;
`

const ContentDiv = styled.div`
  border-bottom: ${({ noBorderBottom }: Object) => (noBorderBottom ? 'none' : '1px solid #f1f1f1')};
  margin: ${({ noBorderBottom }: Object) => (noBorderBottom ? '10px 0 0 0' : '10px 0')};
  padding: 8px 0;
`

type Props = {|
  isOpen: boolean,
  onClose: Function,
  children: any,
  onSearchChange?: Function,
  searchString?: string,
  header: string,
  searchPlaceholder?: string,
  maxWidth?: number | string,
  searchable?: boolean,
  hideBtn?: boolean,
  btnText?: string
|}

export default function Modal(props: Props) {
  const {
    isOpen,
    onClose,
    children,
    onSearchChange,
    searchString,
    header,
    searchPlaceholder,
    maxWidth,
    searchable,
    hideBtn,
    btnText
  } = props

  return (
    <ResponsiveModal
      open={isOpen}
      styles={{ modal: { width: '100%', maxWidth: maxWidth || '100%' } }}
      classNames={{ closeIcon: 't-ModalCloseIcon' }}
      onClose={onClose}
    >
      <div>
        <h2>{header}</h2>
        {searchable && (
          <SearchInput
            className="p-Modal__search"
            type="text"
            placeholder={searchPlaceholder}
            value={searchString}
            onChange={(event) => onSearchChange && onSearchChange(event.target.value)}
          />
        )}
        <ContentDiv noBorderBottom={hideBtn}>{children}</ContentDiv>
        {!hideBtn && (
          <div>
            <a
              href="#"
              className="blue-button"
              onClick={(e) => {
                e.preventDefault()
                onClose()
              }}
            >
              {btnText || t('ok_btn')}
            </a>
          </div>
        )}
      </div>
    </ResponsiveModal>
  )
}
